import { OrderState, OrderType } from '@protos/v2/order';
import { ArrayValues, ValueOf } from 'type-fest';
import { TRADING_BLOTTER_COLUMNS } from '../../trading-blotter/tradingBlotterTypes';

export const OrderTrackerOrderTypeList = ['all', OrderType.LIMIT, OrderType.FILL_OR_KILL] as const;
export type OrderTrackerOrderType = ArrayValues<typeof OrderTrackerOrderTypeList>;

export const OrderTrackerOrderStateList = [
  'all',
  OrderState.NEW,
  OrderState.PARTIALLY_FILLED,
  OrderState.FILLED,
  OrderState.CANCELLED,
  OrderState.ERRORED,
  OrderState.EXPIRED,
] as const;
export type OrderTrackerOrderState = ArrayValues<typeof OrderTrackerOrderStateList>;

export const OrderTrackerWorkingOrderStates: readonly OrderTrackerOrderState[] = [OrderState.NEW, OrderState.PARTIALLY_FILLED] as const;
export const OrderTrackerCompletedOrderStates: readonly OrderTrackerOrderState[] = [
  OrderState.CANCELLED,
  OrderState.FILLED,
  OrderState.ERRORED,
  OrderState.FILLED,
] as const;

export type OrderTrackerColDefListKey = ValueOf<Pick<ValueOf<typeof TRADING_BLOTTER_COLUMNS, number>, 'field'>> | 'created_timestamp';
export const OrderTrackerColDefList = TRADING_BLOTTER_COLUMNS.map(m => m.field as unknown as OrderTrackerColDefListKey);

export interface OrderTrackerTabData {
  index: number;
  orderType: OrderTrackerOrderType;
  orderState: OrderTrackerOrderState[];
  productSymbol: string | undefined;
  selectedColumns: OrderTrackerColDefListKey[];
  showUserOrdersOnly: boolean;
  tradingAccount: string;
  tabName?: string;
}

export enum OrderTrackerQuickView {
  All = 0,
  Working = 1,
  Limits = 2,
  Completed = 3,
}
